import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  templates: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  agreements: state => state.templates,

  getById: (state) => (id) => {
    return state.templates.find(template => template.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of projects.
   */
  getList ({ commit }, payload) {
    return http.get(`/settings/sign-requests/templates/list`, {params: payload}).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the projects state.
  */
  [SET_LIST] (state, templates) {
    state.templates = templates
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
